import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook} from '@fortawesome/free-solid-svg-icons'

export const ReportButton = ({ userCount, setShowBtn, reportData, setReportedUserData }) => {

  const handleShow = () => {
    setShowBtn(true)
    setReportedUserData(reportData)
  };

    return(
        <React.Fragment>
           <div className="custom-button">
            <span>{userCount}</span>
            <FontAwesomeIcon className="image-button-icon" icon={faAddressBook} onClick={() => handleShow()} ></FontAwesomeIcon>
           </div>
        </React.Fragment>
    )
};